export const RIGHTWARDS_ARROW = ' \u2192';
